import DyteClient from '@cloudflare/realtimekit';
import { useSearchParams } from 'react-router-dom';

import DyteAudio from 'components/DyteAudio';
import { RtkParticipantsAudio } from '@cloudflare/realtimekit-react-ui';

const MeetingAudio = ({ meeting }: { meeting: DyteClient | null }) => {
  const [searchParams] = useSearchParams();
  const forTutorManager = searchParams.get('forTM')?.toLowerCase() === 'true';
  const source = searchParams.get('source');
  const studentId = searchParams.get('studentId');

  // For LiveKit or when meeting is null, don't render Dyte-specific audio components
  if (!meeting) {
    return null;
  }

  // For parent source, use DyteAudio with filtering to only send tutor and selected student audio
  // For tutor manager, also use DyteAudio
  // Otherwise, use default DyteParticipantsAudio
  if (source === 'parent' || forTutorManager) {
    return <DyteAudio source={source} studentId={studentId} />;
  }

  return <RtkParticipantsAudio meeting={meeting} />;
};

export default MeetingAudio;
